import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
const authenticationModule = namespace('authentication');
let SignInButton = class SignInButton extends Vue {
    async signIn() {
        if (Vue.prototype.$msal) {
            await this.fetchAccessToken();
        }
    }
};
__decorate([
    authenticationModule.Action
], SignInButton.prototype, "fetchAccessToken", void 0);
__decorate([
    authenticationModule.Action
], SignInButton.prototype, "setIsAuthLoading", void 0);
SignInButton = __decorate([
    Component
], SignInButton);
export default SignInButton;
